var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-icon-hamburger",on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('div',{staticClass:"k-icon-hamburger__burger",class:_vm.classes},[_c('span'),_c('span'),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }